import React, { PureComponent } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class BackToTop extends PureComponent {
    render() {
        return (
            <div className={styles.toTopBox}>
                <a href="//help.ifeng.com/" className={styles.suggest} target="_blank" />
                <a href="#" className={styles.backTop} />
            </div>
        );
    }
}

export default errorBoundary(BackToTop);
